/**
 * Central API origin for the revamp / mobile backend.
 * Override per environment with REACT_APP_API_BASE_URL in `.env`.
 */
// export const API_BASE_URL =
//   (typeof process !== "undefined" && process.env?.REACT_APP_API_BASE_URL) || "http://stagingapi.hynt.co.in";

export const API_BASE_URL =
  (typeof process !== "undefined" && process.env?.REACT_APP_API_BASE_URL) || "https://prodapi.hynt.co.in";
// export const API_BASE_URL =
//   (typeof process !== "undefined" && process.env?.REACT_APP_API_BASE_URL) || "http://192.168.2.144:5000";

/** Careers / job listings admin API */
export const ADMIN_API_BASE_URL =
  (typeof process !== "undefined" && process.env?.REACT_APP_ADMIN_API_BASE_URL) ||
  "https://adminstagingapi.hynt.co.in/api";

/** Careers / job listings admin API */
// export const ADMIN_API_BASE_URL =
//   (typeof process !== "undefined" && process.env?.REACT_APP_ADMIN_API_BASE_URL) ||
//   "http://192.168.2.144:3000/api";
